import HttpUtil from "./HttpUtil";

class ApiUtil {
  #vue;
  #HttpUtil;

  constructor(vue) {
    this.#HttpUtil = new HttpUtil(vue);
    this.#vue = vue;
  }

  #url(path) {
    if (!path.startsWith("/")) {
      path = "/" + path;
    }
    return "/" + process.env.VUE_APP_AP_NAME + "/api" + path;
  }

  get(path, params = null, headers = {}, reqLogin = true) {
    return this.#checkToken("get", path, params, headers, reqLogin);
  }

  post(path, params, headers = {}, reqLogin = true) {
    return this.#checkToken("post", path, params, headers, reqLogin);
  }

  put(path, params = null, headers = {}, reqLogin = true) {
    return this.#checkToken("put", path, params, headers, reqLogin);
  }

  delete(path, params = null, headers = {}, reqLogin = true) {
    return this.#checkToken("delete", path, params, headers, reqLogin);
  }

  downloadExcel(path, params = null, headers = {}, reqLogin = true) {
    return this.#checkToken("downloadExcel", path, params, headers, reqLogin);
  }

  #checkToken(method, path, params, headers, reqLogin) {
    let url = this.#url(path);
    if (!headers["contentType"]) {
      headers["contentType"] = "application/json";
    }

    return this.#HttpUtil[method](url, params, headers);
  }
}

export default ApiUtil;
